export default __webpack_public_path__ + "static/media/icon_number_yellow_2.3c92546e.svg";